export default "__VITE_ASSET__DLQ68COJ__"